import { LessonBannerProps } from '@components/learn/lessonBanner/lessonBanner';

const convertLessonToBanner = (lesson: any): LessonBannerProps => {
    return {
        name: lesson.displayName,
        description: lesson.description,
        url: lesson.url,
        iconUrl: lesson.iconUrl,
        status: lesson.isCompleted ? 'completed' : 'notStarted',
        earnedPoints: lesson.earnedPoints,
        score: lesson.doneRecently ? undefined : lesson.potentialPoints,
        uuid: lesson.uuid
    };
};

export default convertLessonToBanner;
